import { Box } from '@mantine/core';
import type { Table } from '@tanstack/react-table';
import { FooterRow } from './FooterRow';

export type FooterProps = {
  table: Table<any>;
};

export const Footer: React.FC<FooterProps> = ({ table }) => (
  <Box className="footer" p={16}>
    <FooterRow
      page={table.getState().pagination.pageIndex + 1}
      pageSize={table.getState().pagination.pageSize}
      total={Number(table.getPageCount())}
      setPageSize={pageSize => {
        table.setPageSize(Number(pageSize));
      }}
      setPage={page => {
        table.setPageIndex(page - 1);
      }}
    />
  </Box>
);
